module.exports = __webpack_public_path__ + "img/astar.25063fbd.png";